const MAX_CHECKS = 10;
const CHECK_INTERVAL = 500;

const isLyticsLoaded = function() {
    return typeof window.jstag !== 'undefined';
};

const whenParsed = function(callback: () => void) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, {once: true});
        return;
    }

    callback();
};

const onLyticsLoaded = function(callback: () => void) {
    if (isLyticsLoaded()) {
        callback();
        return;
    }

    whenParsed(function() {
        let checks = 0;

        const poll = function() {
            if (isLyticsLoaded()) {
                callback();
                return;
            }

            if (++checks >= MAX_CHECKS) {
                return;
            }

            setTimeout(poll, CHECK_INTERVAL);
        };

        poll();
    });
};

export default onLyticsLoaded;
